<template lang="pug">
  a.c-triangle.show-for-medium(:href="seraphinLink")
</template>

<script>
export default {
  computed: {
    seraphinLink () {
      return process.env.SERAPHIN_PATH
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/layout/Navigation.vue